import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { SearchHistoryItem } from '@search/const';
import { SearchActions, SearchSelectors, StateWithSearch } from '@search/data-access';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SearchHistoryService {
  constructor(private store: Store<StateWithSearch>) {}

  get(count: number, text?: string): Observable<SearchHistoryItem[]> {
    return this.store.select(SearchSelectors.getSearchHistoryState).pipe(
      map((items) => {
        if (!text) {
          return items.slice(0, count);
        }

        const matchResults = items.filter((i) => i.text.indexOf(text) !== -1);

        return matchResults.slice(0, count);
      }),
    );
  }

  push(item: SearchHistoryItem): void {
    if (item.text) {
      this.store.dispatch(new SearchActions.SearchHistoryPush(item));
    }
  }

  remove(item: SearchHistoryItem): void {
    this.store.dispatch(new SearchActions.SearchHistoryRemove(item));
  }

  reset(): void {
    this.store.dispatch(new SearchActions.SearchHistoryReset());
  }
}
